<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      <!-- Back Button -->
      <button
        class="back-button"
        (click)="onBack()"
        [class.hidden]="hideBackButton"
        [attr.aria-hidden]="hideBackButton">
        <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
      </button>

      <!-- Passcode Section -->
      <div class="passcode-section">
        <div class="lock-icon-container">
          <mzic-svg src="assets/icons/mzic-lock.svg" class="lock-icon" />
        </div>

        <h1 class="passcode-title">{{ t('lang.passcode_title') }}</h1>
        <p class="passcode-description">
          {{ t('lang.passcode_description') }}
        </p>

        <!-- Digit Inputs -->
        <div class="digits-container" [class.error]="hasError">
          @for (digit of digits(); track $index) {
            <input
              type="tel"
              inputmode="numeric"
              maxlength="1"
              class="digit-input"
              [id]="'digit-' + $index"
              [value]="digit"
              (input)="onDigitInput($index, $event)"
              (keydown)="onDigitKeyDown($index, $event)"
              (paste)="onDigitPaste($event)"
              [class.filled]="digit"
              [class.error]="hasError"
              [disabled]="isDisabled" />
          }
        </div>

        <!-- Backoff Timer -->
        @if (backoffSeconds > 0) {
          <div class="backoff-message">
            <p>Too many attempts. Please wait {{ backoffSeconds }} seconds.</p>
          </div>
        }

        <!-- Help Text -->
        <p class="help-text">
          {{ t('lang.passcode_help') }}
        </p>
      </div>
    </div>
  </div>
</ng-container>
